import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutation';
import actions from './action';
// import {
//   objInit
// } from '../assets/js/objInit';
//
// const productInit = objInit.productInit();

Vue.use(Vuex);

const state = {
  projectList:[],
  showMaskFlag: false,
  token: '',
  isLoading: false,
  previewImgUrl: '',//图片预览
  imgUrl:'',
  userInfo: {},
  cityList: [],//用户城市列表
  permissionCityList: [], // 有权限城市列表
  district: null,
  center: [],
  userAuth:[],
  menustatus:true,
  insureTypeList: [
    { id: 0, name: '新增客户' },
    { id: 1, name: '自店保单' },
    { id: 2, name: '自店基盘' },
    { id: 3, name: '议价' },
    { id: 4, name: '包干' },
    { id: 5, name: '报废' }
    // { id: 6, name: '争议' },
    // { id: 7, name: '已定损，未维修' }
  ], //定损类型
  accidentLevelList: [ //事故等级
    {
      id: null, label: "全部"
    },
    {
      id: 4, label: "特大事故"
    }, {
      id: 3, label: "大事故"
    }, {
      id: 2, label: "中等事故"
    }, {
      id: 1, label: "小事故"
    }, {
      id: 0, label: "无价值事故"
    },

  ],
  orderSourceStateList: [
    // {
    //   id: null,
    //   label: "全部",
    //   children: [
    //     {
    //       id: null,
    //       label: "全部"
    //     }
    //   ]
    // },
    {
      id: 0,
      label: "后台新建",
      children: [
        {
          id: null,
          label: "全部"
        },
        {
          id: 1022,
          label: "保险公司返修"
        },
        {
          id: 1021,
          label: "保险公司送修"
        },
        {
          id: 1023,
          label: "员工转介绍"
        },
        {
          id: 1024,
          label: "公司渠道1"
        },
        {
          id: 1025,
          label: "公司渠道2"
        },
        {
          id: 1026,
          label: "公司渠道3"
        },
        {
          id: 1000,
          label: "微信群"
        },
        {
          id: 1001,
          label: "调度补录"
        },
        {
          id: 1002,
          label: "个人渠道"
        },
        {
          id: 1003,
          label: "公司渠道"
        },
        {
          id: 1004,
          label: "跟车进店订单"
        },
        {
          id: 1005,
          label: "合作店订单"
        },
        // {
        //   id:1006,
        //   label:"国泰"
        // },
        {
          id: 1007,
          label: "熊猫驾信"
        },
        {
          id: 1008,
          label: "西安特供"
        },
        {
          id: 1009,
          label: "大地保险"
        },
        {
          id: 1010,
          label: "天安"
        },
        {
          id: 1011,
          label: "路遇"
        },
        {
          id: 1012,
          label: "泛华"
        },
        {
          id: 1013,
          label: "阳光"
        },
        {
          id: 1014,
          label: "众信"
        },
        {
          id: 1015,
          label: "中华"
        },
        {
          id: 1016,
          label: "华农"
        },
        {
          id: 1017,
          label: "中达信"
        },
        {
          id: 1018,
          label: "方圆"
        },
        {
          id: 1019,
          label: "沐兴统筹",
        },
        {
          id: 1020,
          label: "平信",
        }
      ]
    },
    {
      id: 1,
      // label: "小程序",
      label: "路采线索",
      children: [
        {
          id: null,
          label: "全部"
        },
        {
          id: 1100,
          label: "上报事故"
        },
        {
          id: 1101,
          label: "拍照定损"
        }
      ]
    },
    // {
    //   id: 2,
    //   label: "现场补录",
    //   children: [
    //     {
    //       id: null,
    //       label: "全部"
    //     },
    //     {
    //       id: 1200,
    //       label: "及时雨补录"
    //     },
    //   ]
    // },
    // {
    //   id: 5,
    //   label: "微信公众号",
    //   children: [
    //     {
    //       id: null,
    //       label: "全部"
    //     },
    //     {
    //       id: 1500,
    //       label: "一键救援"
    //     },
    //     {
    //       id: 1501,
    //       label: "客户送修"
    //     },
    //     {
    //       id: 1502,
    //       label: "客户补录"
    //     }
    //   ]
    // },
    // {
    //   id: 6,
    //   label: "4S店推送",
    //   children: [
    //     {
    //       id: null,
    //       label: "全部"
    //     },
    //     {
    //       id: 1600,
    //       label: "4S店推送"
    //     }
    //   ]
    // },
    // {
    //   id: 7,
    //   label: "合作渠道",
    //   children: [
    //     {
    //       id: null,
    //       label: "全部"
    //     },
    //     {
    //       id: 1007,
    //       label: "熊猫驾信"
    //     },
    //     {
    //       id: 1008,
    //       label: "西安特供"
    //     }
    //   ]
    // },
    {
      id: 8,
      label: "自有线索",//"4S自店信息",
      children: [
        {
          id: null,
          label: "全部"
        },
        {
          id: 1801,
          label: "保险公司送修"
        },
        {
          id: 1802,
          label: "保险公司返修"
        },
        {
          id: 1803,
          label: "社会自店采集"
        },
        {
          id: 1804,
          label: "推修公司提供"
        },
        {
          id: 1805,
          label: "内部员工转介绍"
        },
        {
          id: 1807,
          label: "自然进店"
        },
        {
          id: 1808,
          label: "车机线索"
        },
        {
          id: 1806,
          label: "其他"
        },
        {
          id: 1899,
          label: "自店保险采集"
        },
      ]
    },
    // {
    //   id: 10,
    //   label: "店内外派",
    //   children: [
    //     {
    //       id: null,
    //       label: "全部"
    //     },
    //     {
    //       id: 1900,
    //       label: "自店信息",
    //     }
    //   ]
    // }
    {
      id: 11,
      label: "APP直接送修",
      children: [
        {
          id: null,
          label: "全部"
        },
        {
          id: 2110,
          label: "APP直接送修"
        }
      ]
    },
    {
      id: 12,
      label: "APP现场服务",
      children: [
        {
          id: null,
          label: "全部"
        },
        {
          id: 2210,
          label: "APP现场服务"
        }
      ]
    },
    {
      id: 13,
      label: "渠道推送",
      children: [
        {
          id: null,
          label: "全部"
        },
        {
          id: 3110,
          label: "渠道推送"
        }
      ]
    },
    {
      id: 14,
      label: "渠道现场服务",
      children: [
        {
          id: null,
          label: "全部"
        },
        {
          id: 4110,
          label: "渠道现场服务"
        }
      ]
    },
    {
      id: 15,
      label: "渠道其他",
      children: [
        {
          id: null,
          label: "全部"
        },
        {
          id: 5110,
          label: "渠道其他"
        }
      ]
    },
  ]
  ,
  accidentDirectionList: [ //事故方向
    {
      id: 0, label: "南向北"
    }, {
      id: 1, label: "北向南"
    }, {
      id: 2, label: "东向西"
    }, {
      id: 3, label: "西向东"
    },
    {
      id: 4, label: "进城"
    }, {
      id: 5, label: "出城"
    },
  ],
  accidentStateList: [ //信息有效性
    {
      id: null, label: "全部"
    },
    {
      id: 0, label: "有效"
    }, {
      id: 1, label: "重复"
    }, {
      id: 2, label: "无效"
    }
  ],

  accidentRoadTypeList: [ //事故道路类型
    {
      id: 0, label: "主路"
    }, {
      id: 1, label: "辅路"
    }
  ],
  accidentCarNumList: [ //事故车辆类型
    {
      id: 0, label: "单车事故"
    }, {
      id: 1, label: "两车事故"
    },
    {
      id: 2, label: "多车事故"
    }
  ],
  timelyRainStateList: [ //及时雨状态枚举
    {
      id: null, label: "全部"
    },
    {
      id: 0, label: "空闲"
    }, {
      id: 1, label: "离线"
    },
    {
      id: 2, label: "忙碌"
    },
    {
      id: 3, label: "暂不接单"
    }
  ],
  tagTypeList: [
    {name: "救援大师", id: 100},
    {name: "王者战士", id: 200},
    {name: "钻石战士", id: 300},
    {name: "黄金士兵", id: 400},
  ],
};

export default new Vuex.Store({
  state,
  actions,
  mutations
});





// WEBPACK FOOTER //
// ./src/store/index.js